<template>
  <div id="app" class="app">
    <LoadingComponent v-show="pageLoading"></LoadingComponent>
    <router-view v-if="activityData" :activityData="activityData" :baseData="baseData" />
    <base-component :baseData="baseData" :activityData="activityData" v-if="baseData"></base-component>
  </div>
</template>

<script>
import COVER from "@/utils/COVER";
import BaseComponent from "@/components/Base";
import LoadingComponent from "@/components/LoadingToast";

import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      activityData: null,
      baseData: null,
    };
  },
  created() {
    const aid = this.$route.query.id || "";
    this.setAid(aid);
    this.getActivityData();
  },
  mounted () {
      this.rem();
      window.addEventListener('resize', this.rem);
  },
  computed: {
    ...mapState(["pageLoading", "aid"]),
  },
  components: {
    BaseComponent,
    LoadingComponent,
  },
  methods: {
    ...mapMutations(["setAid", "setUserinfo"]),
    getActivityData() {
      COVER.$get("/activity/config", {
        aid: this.aid,
      }).then((res) => {
        if (res.errno == 0) {
          let data = res.data;
          document.title = data.title;
          this.activityData = Object.assign(data.templateConfig, {
            title: data.title,
            isAppShow: data.isAppShow,
          });
          this.baseData = Object.assign(
            {
              isAppShow: data.isAppShow,
              music: data.music,
              share: data.share,
              isEnd: data.serverTime >= new Date(data.endTime).getTime(),
            },
            data.openApp || {}
          );
        } else {
        }
      });
    },
    rem () {
        // 部分安卓手机内置浏览器rem校准
        function adapt(){  
            var d = window.document.createElement('div');
            d.style.width = '1rem';
            d.style.display = 'none';
            var head = window.document.getElementsByTagName('head')[0];
            head.appendChild(d);
            var defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));
            return defaultFontSize;
        };
        var w = document.documentElement.clientWidth / 10;
        document.documentElement.style.fontSize = (w > 50 ? 50 : w) + 'px';
        if (w != adapt() && /android/i.test(navigator.userAgent)) {
            w = w / adapt() * (document.documentElement.clientWidth / 10);
            document.documentElement.style.fontSize = w + 'px';
        }
    }
  },
};
</script>

<style lang="less">
body {
    max-width: 720px;
    margin: 0 auto !important;
}
</style>
